
import { mapGetters } from "vuex";
import appTile from "./app-tile.vue";
export default {
  components: { appTile },
  computed: {
    ...mapGetters("apps", ["getRecommendedApps"])
  }
};
